import { createContext, useContext, type ReactNode } from 'react';
import { useSession } from '@cdn/identity';
import { useObservable } from '@cdn/state';
import type { Admission } from './admission';

const Context = createContext<Admission | undefined>(undefined);

export function AdmissionProvider({ admission, children }: { admission: Admission; children: ReactNode }) {
	return <Context.Provider value={admission}>{children}</Context.Provider>;
}

/**
 * The person's admission, observed together with the session, because `admission.can()` answers from both
 */
export function useAdmission(): Admission {
	const admission = useContext(Context);
	if (!admission) throw new Error('useAdmission needs an AdmissionProvider');
	useSession();
	return useObservable(admission);
}
